import Serializer from 'umg-ember-backend/serializers/application';

export default class ProductTrackContributorSerializer extends Serializer {
  attrs = {
    productTrack: 'track',
  };
}
